<template>
    <div class="dropdown ini-filteritem" :class="['ini-filteritem__' + name, {'ini-filteritem--active': hasSelection}]" 
         v-click-outside="resetItem" @click.capture="resizeItem" v-bind:style="{ minWidth: triggerMinWidth }">
        <span class="btn ini-filteritem__label" data-toggle="dropdown">
            <span>{{ title }}</span>
            <i class="zmdi zmdi-chevron-down"></i>
        </span>
        <div class="dropdown-menu ini-filteritem__options" ref="dropdown">
            <ini-badge :closable='isSelected(option)' class="dropdown-item" v-for="option in options"
                       :data-value="option.id" :name="name" :value="option.id" :selected="isSelected(option)"
                       @close="removeFilter(option)" @click.native.prevent.stop="selectFilter(option)" :label="option.label">
            </ini-badge>
        </div>
        <div v-if="hasSelection" class="ini-filteritem__selections">
            <span v-for="option in this.selections" class="ini-filteritem__selection">
                <ini-badge :closable="isSelected(option)" uppercase :name="name" :value="option.id"
                           :selected="isSelected(option)" @close="removeFilter(option)" :label="option.label">
                </ini-badge>
            </span>
        </div>
    </div>
</template>

<script>
    import StyleMixin from '@/mixins/StyleMixin.js'
    import IniBadge from '@/components/HelpDesk/List/FilterBadge'
    import TicketPriority from "@/components/HelpDesk/TicketPriority"

    export default {
        mixins: [StyleMixin],

        data() {
            return {
                selections: {},
                triggerMinWidth: 'auto'
            }
        },

        props: {
            title: String,
            name: String,
            options: Array
        },

        components: {
            IniBadge,
            TicketPriority
        },

        computed: {
            hasSelection() {
                if(Object.keys(this.selections).length > 0){
                    return true
                }

                return false
            }
        },

        methods: {
            selectFilter(option) {
                this.$set(this.selections, option.id, option)
            },

            removeFilter(option) {
                this.$delete(this.selections, option.id)
    
                if(Object.keys(this.selections).length === 0){
                    this.triggerMinWidth = 'auto';
    
                    if($(this.$refs.dropdown).hasClass('show')){
                        $(this.$refs.dropdown).removeClass('show')
                    }
                }
            },

            isSelected(option){
                if(option.id in this.selections){
                    return true
                }

                return false
            },
    
            resizeItem(event){
                let target = $(event.target)
                let filterItem = target.closest('.ini-filteritem')
                this.triggerMinWidth = filterItem.find('.dropdown-menu').outerWidth();
            },
    
            resetItem(event){
                if(Object.keys(this.selections).length === 0){
                    this.triggerMinWidth = 'auto';
                }
                
                if($(this.$refs.dropdown).hasClass('show')){
                    $(this.$refs.dropdown).removeClass('show')
                }
            },
        },

        watch: {
            selections(val) {
                let keys = Object.keys(val)
                this.$emit('change', keys)
            },
            triggerMinWidth(val){
                $(this.$el).css({'min-width': val})
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/List/_filteritem.scss";</style>